module.exports = __webpack_public_path__ + "img/nav-bar.f3196a9d.png";